import { ReactNode } from "react";
import iBlueLine from "../../../../../assets/icons/about-us-page/blue-line.svg";
import { useWidth } from "../../../../../hooks/use-width";
import "./timeline-block-item.sass";

type Props = {
  img: string;
  year: string;
  children: ReactNode;
};

const AboutUsTimelineBlockItem = ({ img, children, year }: Props) => {
  const { isDesktopWidth } = useWidth();

  return isDesktopWidth ? (
    <div className="timeline-block-item">
      <div className="timeline-block-item__left">
        <img src={img} className="timeline-block-item__img" alt="" />
      </div>

      <div className="timeline-block-item__divider">
        {year}
        <img src={iBlueLine} className="timeline-block-item__line" alt="" />
      </div>

      <div className="timeline-block-item__text">{children}</div>
    </div>
  ) : (
    <div className="timeline-block-item">
      <div className="timeline-block-item__divider">{year}</div>

      <div className="timeline-block-item__left">
        <img src={img} className="timeline-block-item__img" alt="" />

        <div className="timeline-block-item__text">{children}</div>
      </div>
    </div>
  );
};

export default AboutUsTimelineBlockItem;
